import { MONTHS_IN_YEAR } from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";

export const getYearMonths = (year: number): Date[] =>
	Array.from(
		{ length: MONTHS_IN_YEAR },
		(_, monthIndex) => new Date(year, monthIndex, 1),
	);
